import React from 'react'

import i18next from 'i18next'

import { Badge } from '~/components/UI/Badge'
import { isReadOnly } from '~/helpers'

export const campaignStrategiesOptions: RadioOptionProps[] = [
  {
    id: `strategy_objective_based`,
    name: `strategy_objective_based`,
    value: `objective_based`,
    label: i18next.t(`rm:campaign.objective_based`),
    disabled: isReadOnly(),
    icon: <Badge text="beta" size="small" className="ms-1" template="warning" />
  },
  {
    id: `strategy_standard`,
    name: `strategy_standard`,
    value: `standard`,
    label: i18next.t(`rm:campaign.standard`),
    disabled: isReadOnly()
  }
]

export const campaignStrategiesChecks: CheckboxOptionProps[] = [
  {
    id: `strategy_objective_based_check`,
    name: `strategy_objective_based`,
    value: `objective_based`,
    label: i18next.t(`rm:campaign.objective_based`),
    disabled: isReadOnly(),
    icon: <Badge text="beta" size="small" className="ms-1" template="warning" />
  },
  {
    id: `strategy_standard_check`,
    name: `strategy_standard`,
    value: `standard`,
    label: i18next.t(`rm:campaign.standard`),
    disabled: isReadOnly()
  }
]
